import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-dark text-light mt-5">
      <div className="container py-4 text-center">
        <p className="mb-2 small">
          © {new Date().getFullYear()} MarketLuz. Todos los derechos reservados.
        </p>

        {/* LINKS LEGALES */}
        <div className="d-flex justify-content-center flex-wrap gap-3 mb-3">
          <Link
            to="/terminos-y-condiciones"
            className="text-warning text-decoration-none small"
          >
            Términos y Condiciones
          </Link>

          <span className="text-secondary">|</span>

          <Link
            to="/politica-de-privacidad"
            className="text-warning text-decoration-none small"
          >
            Política de Privacidad
          </Link>

          <span className="text-secondary">|</span>

          <Link
            to="/cambios-y-devoluciones"
            className="text-warning text-decoration-none small"
          >
            Política de Cambios, Devoluciones y Reembolsos
          </Link>

          <span className="text-secondary">|</span>

          <Link
            to="/informacion-del-comercio"
            className="text-warning text-decoration-none small"
          >
            Información del Comercio
          </Link>
        </div>

        {/* BOTÓN INSTAGRAM */}
        <div>
          <a
            href="https://www.instagram.com/marketluz_peru/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-danger btn-sm"
          >
            Síguenos en Instagram
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;